<style lang="scss">
    @import "./login.css";
</style>

<template>
    <div class="loginPage">
        <a-card hoverable>
            <div class="loginCard">
                <div class="cardLeft">
                    <img src="../../image/logo.png" class="logoImg">
                </div>
                <div class="cardRight">
                    <div class="dlMessBgTop"></div>
                    <div class="dlTitle">
                        集團管理系統登錄
                    </div>
                    <a-form-model :form="form" ref="ruleForm" :model="form" :rules="rules">
                        <a-form-model-item ref="name" prop="name">
                            <a-input class="loginInput" v-model="form.name" onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')" :maxLength=50 auto-complete="new-accounts" placeholder="請輸入帳戶名">
                                <div slot="prefix" class="inputIconBefore">
                                    <img src="../../image/icon_zhanghao.png" class="iconImg">
                                </div>
                            </a-input>
                            <div class="marginView"></div>
                        </a-form-model-item>
                        <a-form-model-item ref="password" prop="password">
                            <a-input v-model="form.password" onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')" :maxLength=20 auto-complete="new-password" placeholder="請輸入密碼" :type="passwordBol ? 'password' : 'text'">
                                <div slot="prefix" class="inputIconBefore">
                                    <img src="../../image/icon_lock.png" class="iconImg">
                                </div>
                                <!-- <a-icon slot="suffix" :type="passwordBol ? 'eye-invisible' : 'eye'" @click="passwordBol =! passwordBol"/> -->
                                <div slot="suffix" @click="passwordBol =! passwordBol">
                                    <img :src="passwordBol ? eyeOFF : eyeON" class="iconImg">
                                </div>
                            </a-input>
                            <div class="marginView"></div>
                        </a-form-model-item>
                        <a-form-model-item ref="identfy" prop="identfy">   
                            <div class="flexMiddleBox">
                                <a-input @pressEnter='loginEvent' class="ideInput" onkeyup="value=value.replace(/[^\w\.\/]/ig,'')" :maxLength=4 v-model="form.identfy" placeholder="請輸入驗證碼">
                                    <div slot="prefix" class="inputIconBefore">
                                        <img src="../../image/icon_pic.png" class="iconImg">
                                    </div>
                                </a-input>
                                <div class="sIdentify" @click="refreshCode">
                                    <s-identify1 v-if="screenFlag<=1024" :identifyCode="identifyCode"></s-identify1>
                                    <s-identify v-else :identifyCode="identifyCode"></s-identify>
                                </div>
                            </div>
                            <div class="marginView"></div>
                        </a-form-model-item>
                        <a-form-model-item style="margin-bottom:0;">
                            <div class="btnOnItem"></div>
                            <div class="flexView">
                                <!-- <a-checkbox @change="remEvent" :defaultChecked="remCheck">記住我</a-checkbox> -->
                                <a-button block type="primary" @click="loginEvent()" style='color: #fff !important;' :loading="loadingBol">登 錄</a-button>
                            </div>
                        </a-form-model-item>
                    </a-form-model>
                    <div class="dlMessBg"></div>
                </div>
            </div>
        </a-card>
    </div>
</template>

<script>

    import App from '@/assets/app.js'

    import apiUrl from '@/assets/api.js'

    import https from '@/plugins/http.js'

    import SIdentify from '@/components/identifyImg/identifyImg.vue';
    import SIdentify1 from '@/components/identifyImg/identifyImg1.vue';

    // import menuList from '@/assets/frameWork.js';

    import eyeON from '../../image/iocn_kejian.png';
    import eyeOFF from '../../image/iocn_yincang.png';

    export default {
        components: {
            's-identify': SIdentify,
            's-identify1': SIdentify1,
        },
        data() {
            let _this = this;
            let checkIdentfy = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('請輸入驗證碼'));
                }else if(!Object.is(_this.identifyCode,_this.form.identfy)){
                    callback(new Error('請輸入正確的驗證碼'));
                }else{
                    callback();
                }
            };
            return {
                screenFlag:window.innerWidth,
                eyeON,
                eyeOFF,
                // 登錄加載中判斷
                loadingBol : false,
                // 記住是否保存帳號
                remCheck : true,
                // 判斷密碼是否隱藏
                passwordBol : true,
                // 表單數據
                form: {
                    name: '',
                    password: '',
                    identfy: ''
                },
                rules: {
                    name: [
                        {required: true, message: '請輸入帳戶名'},
                    ],
                    password: [
                        {required: true, message: '請輸入密碼'},
                    ],
                    identfy: [
                        {validator: checkIdentfy},
                    ],
                },
                identifyCodes: '1234567890abcdefg',
                identifyCode: '',
                // 侧边栏数据
                menuList : [],
            };
        },
        beforeMount(){
            let _this = this;
            if(localStorage.getItem('name')){
                _this.form.name = localStorage.getItem('name');
                _this.form.password = localStorage.getItem('password');
            }
        },
        mounted() {
            this.identifyCode = '';
            this.makeCode(this.identifyCodes, 4);
		
        },
        methods: {
			funchild(arrchild,str){
				arrchild.map(ev=>{
					if(ev[str].length == 0){
						delete arrchild[str]
					}else if(ev[str].length){
						this.funchild(arrchild,str)
					}
				});
				console.log(arrchild)
				return arrchild;
			},
			//获取菜单
			menuListFn(token){
				this.$ajax({
					method:'post',
					url:this.$api.AdminGetMenuList,
					headers: {
						token: token
					},
					data:{token: token}
				}).then(res =>{
					if(res.data.qmiscode === 1000){
						// let arr = this.funchild(res.data.firstLevel,'secondLevel')
						this.menuList = res.data.firstLevel
						//defaultFirstMenuid :6  defaultSecondMenuid : null
							/* defaultFirstMenuid :8
							defaultSecondMenuid : 3 */
							// defaultFirstMenuid :null
							// defaultSecondMenuid : null
						//
						this.$store.commit('startpage',[res.data.defaultSecondMenuid,res.data.defaultFirstMenuid])
						localStorage.setItem('menuList', JSON.stringify(this.menuList));
						
					}else{
						  App.oTool.warningT(data.qmismsg);
					}
				})
			},
            remEvent(e){
                let _this = this;
                _this.remCheck = e.target.checked;
            },
            // 登錄
            loginEvent() {
                let _this = this;
                _this.$refs.ruleForm.validate(valid => {
                    if(valid) {
                        _this.loadingBol = true;
                        https.fetchLoginPost(apiUrl.adminlogin,{
                            name : _this.form.name,
                            password : _this.form.password,
                        }).then((data) => {
                            if(Object.is(data.qmiscode,1000)){
                                data.loginName = _this.form.name;
                                _this.$store.commit('adminlogin',data);
								_this.$store.commit('startpage',['',''])
								_this.menuListFn(data.token)
                                _this.loadingBol = false;
                                // if(_this.remCheck){
                                //     localStorage.setItem('name', _this.form.name);
                                //     localStorage.setItem('password', _this.form.password);
                                // }
                                // if(Object.is(data.position,'超級系統管理員')){
                                //     _this.menuList[0].show = true;
                                //     localStorage.setItem('menuList',JSON.stringify( _this.menuList));
                                // }else{
                                //     _this.menuList[0].show = false;
                                    // localStorage.setItem('menuList', JSON.stringify(_this.menuList));
                                // }
								App.oTool.successT('登錄成功！',1.5,() => {
									_this.$store.commit('handtitle','')
										let url = ''
                                        
                                        for (let i = 0; i < _this.menuList.length; i++) {
                                            if (_this.menuList[i].secondLevel.length>0) {
                                               for (let j = 0; j < _this.menuList[i].secondLevel.length; j++) {
                                                    if (_this.menuList[i].secondLevel[j].thirdLevel.length<=0) {
                                                        console.log("二级");
                                                        url = _this.menuList[i].secondLevel[j].url
                                                        if (url == '/main/homePage' ||  url == '/main/homePage1') {
                                                            _this.$store.commit('handtitle','')
                                                        }else{
                                                            _this.$store.commit('handtitle',_this.menuList[i].secondLevel[j])
                                                        }
                                                        if (url == '/main/homePage') {
                                                            _this.$router.push({path: '/main/homePage1'});
                                                        }else{
                                                            _this.$router.push({path: url});
                                                        }
                                                        return
                                                    }else{
                                                        console.log('三级');
                                                        url = _this.menuList[i].secondLevel[j].thirdLevel[0].url
                                                        _this.$store.commit('handtitle',_this.menuList[i].secondLevel[j].thirdLevel[0])  
                                                        console.log(_this.menuList[i].secondLevel[j].thirdLevel[0]);
                                                        _this.$router.push({path: url});
                                                        return
                                                     
                                                    }
                                                
                                               }
                                            }else{
                                                url = _this.menuList[i].url
                                                _this.$store.commit('handtitle',_this.menuList[i])
                                                _this.$router.push({path: url});
                                                return
                                            }
                                        }
										// _this.menuList.map(ev=>{
                                        //     if (ev.secondLevel.length>0) {
                                        //         ev.secondLevel.map(vals=>{
                                        //             if (vals.thirdLevel.length>0) {
                                        //                 url = vals.thirdLevel[0].url
                                        //                 _this.$store.commit('handtitle',vals.thirdLevel[0])  
                                        //             }else{
                                        //                 url = vals.url
                                        //                 _this.$store.commit('handtitle',vals)  
                                        //             }
                                        //         })
                                        //     }else{
                                        //         url = ev.url
                                        //         _this.$store.commit('handtitle',ev)
                                        //     }
										// 	// if(ev.menuid == _this.$store.state.openKeys){
										// 	// 	if(ev.secondLevel.length>0 ){
										// 	// 		ev.secondLevel.map(vals=>{
										// 	// 			console.log(vals)
										// 	// 			if(vals.menuid == _this.$store.state.keyIndex){
										// 	// 				url = vals.url
										// 	// 				_this.$store.commit('handtitle',vals)
										// 	// 			}
										// 	// 		})
										// 	// 	}else{
										// 	// 		url = ev.url
										// 	// 		_this.$store.commit('handtitle',ev)
										// 	// 	}
										// 	// }
										// })
								        // _this.$router.push({path: url});
								})
                            }else{
                                _this.loadingBol = false;
                                App.oTool.warningT(data.qmismsg);
                            }
                        }).catch(err => {
                            console.log(err);
                            _this.loadingBol = false;
                        });
                    }
                });
            },
            // 驗證碼相關
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min)
            },
            refreshCode() {
                this.identifyCode = '';
                this.makeCode(this.identifyCodes, 4);
            },
            makeCode(o, l) {
                for (let i = 0; i < l; i++) {
                    this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
                }
            }
        },
    };
</script>
